module.exports = __webpack_public_path__ + "img/nautilus-reels-1.34b89ecc.png";